import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, List, ListItemButton, Toolbar } from "@mui/material";
import React, { useState } from "react";
import {
  ListItemSubMenuWrapper,
  ListItemTopMenuWrapper,
  DrawerWrapper,
} from "./Styled";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useModuleAccessNavContext } from "context/ModuleAccessNavContext";

export const MenuListItems = ({
  toggleSideBarAction,
  isSideBarIsOpen,
  parentMenu,
}) => {
  const [openMenus, setOpenMenus] = useState({
    [parentMenu]: true,
  });
  const { navItems } = useModuleAccessNavContext();
  const navigate = useNavigate();
  const { subModuleAccess } = useSelector((state) => state.roles.state);

  const handleMenuClick = (menu) => {
    setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };
  const handleSubMenuItemClick = (path) => {
    navigate(path);
  };
  let elements = [];

  navItems.forEach((item) => {
    elements.push(
      <div key={item.name}>
        <ListItemTopMenuWrapper onClick={() => handleMenuClick(item.name)}>
          <ListItemButton>{item.name}</ListItemButton>
          {openMenus[item.name] ? <ExpandLess /> : <ExpandMore />}
        </ListItemTopMenuWrapper>
        {item.subModule.map(
          (subItem, index) =>
            subModuleAccess[subItem.accessCode] && (
              <Collapse
                in={openMenus[item.name]}
                timeout="auto"
                unmountOnExit
                key={index}
              >
                <List disablePadding>
                  <ListItemSubMenuWrapper>
                    <ListItemButton
                      onClick={() => {
                        handleSubMenuItemClick(subItem.feLink);
                      }}
                    >
                      {subItem.name}
                    </ListItemButton>
                  </ListItemSubMenuWrapper>
                </List>
              </Collapse>
            )
        )}
      </div>
    );
  });

  return (
    <>
      {/* Left Sidebar */}
      <DrawerWrapper
        variant={"temporary"}
        open={isSideBarIsOpen} // Sidebar visibility controlled by state
        onClose={toggleSideBarAction}
        ModalProps={{
          keepMounted: true, // Better performance on mobile
        }}
      >
        <Toolbar />
        <List>{elements}</List>
      </DrawerWrapper>
    </>
  );
};
